/**
 * @generated SignedSource<<d2c04596b95bbb2f669ddbe6b07f86ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternFooterItemKind = "COPY" | "LINK" | "MENU" | "%future added value";
export type InternFooterQuery$variables = {
  id: any;
};
export type InternFooterQuery$data = {
  readonly node: {
    readonly __typename: "GraphQLJobRun";
    readonly internFooterItems: ReadonlyArray<{
      readonly iconKey: string;
      readonly id: string;
      readonly kind: InternFooterItemKind;
      readonly label: string;
      readonly menuItems: ReadonlyArray<{
        readonly label: string;
        readonly url: string | null | undefined;
        readonly value: string | null | undefined;
      }>;
      readonly tooltip: string;
      readonly url: string | null | undefined;
      readonly value: string | null | undefined;
    }>;
  } | {
    readonly __typename: "GraphQLLlmConversation";
    readonly internFooterItems: ReadonlyArray<{
      readonly iconKey: string;
      readonly id: string;
      readonly kind: InternFooterItemKind;
      readonly label: string;
      readonly menuItems: ReadonlyArray<{
        readonly label: string;
        readonly url: string | null | undefined;
        readonly value: string | null | undefined;
      }>;
      readonly tooltip: string;
      readonly url: string | null | undefined;
      readonly value: string | null | undefined;
    }>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type InternFooterQuery = {
  response: InternFooterQuery$data;
  variables: InternFooterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "InternFooterItem",
    "kind": "LinkedField",
    "name": "internFooterItems",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "iconKey",
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tooltip",
        "storageKey": null
      },
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "InternFooterMenuItem",
        "kind": "LinkedField",
        "name": "menuItems",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v8 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "GraphQLLlmConversation",
  "abstractKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "GraphQLJobRun",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternFooterQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternFooterQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e3b8ea6ad52fa0c35c7952b46606d595",
    "id": null,
    "metadata": {},
    "name": "InternFooterQuery",
    "operationKind": "query",
    "text": "query InternFooterQuery(\n  $id: GlobalID!\n) {\n  node(id: $id) {\n    __typename\n    ... on GraphQLLlmConversation {\n      internFooterItems {\n        id\n        kind\n        iconKey\n        label\n        tooltip\n        url\n        value\n        menuItems {\n          label\n          url\n          value\n        }\n      }\n    }\n    ... on GraphQLJobRun {\n      internFooterItems {\n        id\n        kind\n        iconKey\n        label\n        tooltip\n        url\n        value\n        menuItems {\n          label\n          url\n          value\n        }\n      }\n    }\n    __isNode: __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e86084683b5f17f2af0c09f0df8ca4fd";

export default node;
